import type { CreditReversalOrder } from '~/services/OrdersService';

import { CREDIT_LIKE_TYPES } from './constants';
import type { CashPayment } from './types';

export function getCashPayments(payments: CreditReversalOrder['payments']): Array<CashPayment> {
  return payments?.filter((p) => p.intent === 'sale' && !CREDIT_LIKE_TYPES.includes(p.type)) ?? [];
}
